
import {defineComponent, ComputedRef, ref, Ref, computed, onMounted, reactive, toRaw} from 'vue'
import {useStore} from 'vuex'
import {TableProps, message, TableColumnType, Form} from 'ant-design-vue'

import {StateType as SkuStateType} from '../store'
import {CollectBillResType, TableListQueryParams, PaginationConfig} from '../data'

interface AddSkuData {
  loading: Ref<boolean>
  columns: any
  rowSelection: any
  skuData: Ref<any[]>
  list: Ref<CollectBillResType[]>
  pagination: ComputedRef<PaginationConfig>
  modelRef: any
  handleModal: (e: MouseEvent) => void
  addNewSku: (e: MouseEvent) => void
  handleChangeNumber: (record: any) => void
  handleSearch: (e: MouseEvent) => void
  handleTableChange: (pagination: PaginationConfig) => void
  changeTxt: (t: string, type: string) => string
}

export default defineComponent({
  name: 'addSku',
  props: {
    typeStr: String,
  },
  emits: ['isAddSkuBtn', 'skuEmitData'],
  setup(props, {emit}): AddSkuData {
    const store = useStore<{
      addlogistics: SkuStateType
    }>()

    const loading = ref<boolean>(false)
    const userMsg = JSON.parse(String(localStorage.getItem('userMsg'))) || {}

    const modelRef = reactive({
      skuCode: '',
      declareNameCn: '',
    })

    const slist = ref<CollectBillResType[]>([])
    const rowKeys = ref<any[]>((localStorage.getItem('keys') && JSON.parse(String(localStorage.getItem('keys')))) || [])
    const recordRow = ref<any[]>(
      (localStorage.getItem('record') && JSON.parse(String(localStorage.getItem('record')))) || []
    )

    const skuData = ref<any[]>([])
    const list = ref<CollectBillResType[]>([])

    const red = ref<any[]>([])
    const skey = ref<any[]>([])

    const columns: TableColumnType<CollectBillResType>[] = [
      {title: '数量', dataIndex: 'declareNumber'},
      {title: 'SKU编码', dataIndex: 'skuCode'},
      {title: '申报中文名称', dataIndex: 'declareNameCn'},
      {title: '申报英文名称', dataIndex: 'declareNameEn'},
      {title: '商品属性', dataIndex: 'hasBattery'},
      {title: '单货品申报价值', dataIndex: 'declareValue'},
      {title: '申报币种', dataIndex: 'declareCurrency'},
      {title: '单货品申报重量(g)', dataIndex: 'declareWeight'},
      {title: '单品申报尺寸(长*宽*高)', dataIndex: 'dHeight'},
      {title: '单品实测重量', dataIndex: 'realWeight'},
      {title: '单品实测尺寸(长*宽*高)', dataIndex: 'rHeight'},
      {title: '海关编码', dataIndex: 'hsCode'},
      {title: '备注', dataIndex: 'remarks'},
    ]

    const rowSelection: TableProps['rowSelection'] = {
      preserveSelectedRowKeys: true,
      onChange: (selectedRowKeys: any[], selectedRows?: CollectBillResType[]) => {
        // 已选中的所有skuIds处理
        // console.log('row changed: ', selectedRowKeys)
        // const allSelectedKeys = new Set(JSON.parse(String(localStorage.getItem('keys') || '[]')) || [])
        // const prevSelectedKeys = [...allSelectedKeys]
        // selectedRowKeys.forEach(k => allSelectedKeys.add(k))
        // localStorage.setItem('keys', JSON.stringify([...allSelectedKeys]))

        // rowKeys.value = [...allSelectedKeys]

        // 已选中的所有sku处理
        // const allSelectedRecords = JSON.parse(String(localStorage.getItem('record') || '[]')) || []
        // selectedRows?.forEach(row => {
        //   if (prevSelectedKeys.includes(row.id)) {
        //     return
        //   }

        //   row.isflag = true

        //   allSelectedRecords.push(row)
        // })
        // allSelectedRecords.push(...JSON.parse(JSON.stringify(selectedRows)))
        // localStorage.setItem('record', JSON.stringify(allSelectedRecords))

        // 设置待emit数据
        // slist.value = skuData.value = allSelectedRecords

        // 更新当前展示选择列表
        // list.value.forEach(sku => {
        //   sku.isflag = allSelectedKeys.has(sku.id)

        //   sku.declareNumber = allSelectedRecords.filter(r => r.id === sku.id)?.[0]?.declareNumber || 1
        // })
        rowKeys.value = selectedRowKeys
        const s = JSON.parse(JSON.stringify(selectedRows))
        s.map((r:any) => {
          return r.isflag = true
        })
        list.value.length!=0&&list.value.map((k:any) => {
          if(selectedRowKeys.includes(k.id)){
            return k.isflag = true
          }else{
            return k.isflag = false
          }
        })
        slist.value = skuData.value = s
        localStorage.setItem('keys', JSON.stringify([...selectedRowKeys]))
        localStorage.setItem('record', JSON.stringify(s))
      },
      onSelectAll: (record, selected, selectedRow) => {
        let keys:any[] = []
        let records:any[] = []
        selected.map((k:any) => {
          keys.push(k.id)
          records.push({...k,isflag: true})
        })
        localStorage.setItem('keys', JSON.stringify(keys))
        localStorage.setItem('record', JSON.stringify(records))
      },
      defaultSelectedRowKeys: toRaw(rowKeys.value),
    }

    //添加sku
    const pagination = computed<PaginationConfig>(() => store.state.addlogistics.tableData.pagination)
    const getSkulist = async (params: TableListQueryParams) => {
      loading.value = true
      try {
        const res: boolean = await store.dispatch('addlogistics/getSkuPageListFn', params)
        if (res === true) {
          list.value = store.state.addlogistics.tableData.skulist

          // 更新选中项
          // ;(rowSelection.onChange as any)(toRaw(rowKeys.value), toRaw(recordRow.value))

          // 更新已选中标记, 设置数量
          const allSelectedKeys = new Set(JSON.parse(String(localStorage.getItem('keys') || '[]')) || [])
          const allSelectedRecords = JSON.parse(String(localStorage.getItem('record') || '[]')) || []

          // 更新当前展示选择列表
          list.value.forEach(sku => {
            sku.isflag = allSelectedKeys.has(sku.id)

            sku.declareNumber = allSelectedRecords.filter((r:any) => r.id === sku.id)?.[0]?.declareNumber || 1
          })

          rowSelection.defaultSelectedRowKeys = rowSelection.selectedRowKeys = [...(allSelectedKeys as Set<string>)]
        }
      } catch (error) {
        message.warning('error=>' + error)
      }
      loading.value = false
    }

    const handleModal = (e: MouseEvent) => {
      if (skuData.value.length > 0 && rowKeys.value.length > 0) {
        emit('skuEmitData', skuData.value)
      } else {
        message.warning('请选择SKU')
      }
    }

    const handleChangeNumber = (record: any) => {
      slist.value.map((item: any) => {
        if (record.id == item.id) {
          return (item.declareNumber = record.declareNumber)
        }
      })
      skuData.value = slist.value
    }

    //查询
    const handleSearch = (e: MouseEvent) => {
      const data = {
        skuCode: modelRef.skuCode,
        declareNameCn: modelRef.declareNameCn,
        userCode: userMsg?.userCode,
      }
      getSkulist(data)
    }

    //分页
    const handleTableChange = (pagination: PaginationConfig) => {
      const params = {userCode: userMsg?.userCode, pageNo: pagination.current || 1, pageSize: pagination.pageSize || 10}
      getSkulist(params)
    }

    const addNewSku = (e: MouseEvent) => {
      emit('isAddSkuBtn', true)
    }

    const changeTxt = (t: string, type: string) => {
      const hObj = {0: '普货', 1: '带电'}
      const def = {def: String(t)}
      switch (type) {
        case 'hasBattery':
          return hObj[t] || def['def']
        default:
          return def['def']
      }
    }

    onMounted(() => {
      const data = {
        pageNo: 1,
        pageSize: 10,
        userCode: userMsg.userCode,
      }
      getSkulist(data)
      setTimeout(() => {
        ;(rowSelection.onChange as any)(toRaw(rowKeys.value), toRaw(recordRow.value))
      }, 500)
    })

    return {
      columns,
      rowSelection,
      loading,
      list,
      skuData,
      modelRef,
      pagination,
      handleModal,
      addNewSku,
      handleChangeNumber,
      handleSearch,
      handleTableChange,
      changeTxt,
    }
  },
})
